import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";

import { PageWrapper } from "~/components/page-wrapper";
import SalesCategoriesList from "~/components/settings/sales-categories-list";
import { Skeleton } from "~/components/ui/skeleton";

export const Route = createFileRoute(
  "/_authenticated/settings/sales-categories"
)({
  component: SalesCategoriesPage,
});

function SalesCategoriesPage() {
  return (
    <PageWrapper
      description="Manage sales categories for reporting"
      title="Sales Categories"
    >
      <Suspense fallback={<Skeleton className="h-full w-full" />}>
        <SalesCategoriesList />
      </Suspense>
      {/* Outlet for child routes (e.g., /$categoryId/edit modal) */}
      <Outlet />
    </PageWrapper>
  );
}
